let Init = {
    init: function () {
        this.bind();
    },

    bind: function () {
    },
};


$().ready(() => {
    window.Frontend.Init = Init;
    window.Frontend.Init.init();
});
